var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: `关联游戏 - ${_vm.tagData ? _vm.tagData.title : ""} (已关联 ${
          _vm.pagination.total
        } 个游戏)`,
        visible: _vm.visible,
        width: "1200px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$emit("update:visible", $event)
        },
        closed: _vm.handleDialogClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "page-content page-search" },
        [
          _c(
            "div",
            { staticClass: "search-form-wrap" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form-flex",
                  attrs: {
                    size: "mini",
                    model: _vm.searchForm,
                    "label-position": "right",
                  },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 12 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "游戏名称" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入游戏名称",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.game_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "game_name", $$v)
                                  },
                                  expression: "searchForm.game_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "游戏厂商" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入游戏厂商",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.game_provider,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.searchForm,
                                      "game_provider",
                                      $$v
                                    )
                                  },
                                  expression: "searchForm.game_provider",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 8 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "mini",
                                loading: _vm.loading,
                              },
                              on: { click: _vm.handleSearch },
                            },
                            [_vm._v("筛选")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", disabled: _vm.loading },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "toolbar" }, [
            _c("span", { staticClass: "tip" }, [
              _vm._v(
                "已选择 " + _vm._s(_vm.selectedGameIds.length) + " 个游戏"
              ),
            ]),
          ]),
          _c(
            "el-table",
            {
              ref: "gameTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.gameList,
                border: "",
                stripe: "",
                fit: "",
                "max-height": "400",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "48", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序",
                  width: "220",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "sort-cell" },
                          [
                            !_vm.isSortEditing(scope.row)
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "sort-cell__value" },
                                    [_vm._v(_vm._s(scope.row.sort))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "mini",
                                        disabled: !_vm.getRowGameId(scope.row),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startSortEdit(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v(" 编辑 ")]
                                  ),
                                ]
                              : [
                                  _c("el-input-number", {
                                    staticClass: "sort-cell__input",
                                    attrs: {
                                      min: 1,
                                      step: 1,
                                      precision: 0,
                                      controls: false,
                                      size: "mini",
                                      placeholder: "序号",
                                    },
                                    nativeOn: {
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        return _vm.saveRelatedGameSort(
                                          scope.row
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.sortDraftValue,
                                      callback: function ($$v) {
                                        _vm.sortDraftValue = $$v
                                      },
                                      expression: "sortDraftValue",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "mini",
                                        loading:
                                          _vm.sortSavingId ===
                                          _vm.getRowGameId(scope.row),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.saveRelatedGameSort(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 保存 ")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "text",
                                        size: "mini",
                                        disabled:
                                          _vm.sortSavingId ===
                                          _vm.getRowGameId(scope.row),
                                      },
                                      on: { click: _vm.cancelSortEdit },
                                    },
                                    [_vm._v(" 取消 ")]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "game_name",
                  label: "游戏名称",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "game_provider",
                  label: "游戏品牌",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "game_type",
                  label: "游戏类型",
                  "min-width": "100",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "pagination-container",
          staticStyle: { "margin-top": "16px", "text-align": "right" },
        },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pagination.currentPage,
              "page-size": _vm.pagination.pageSize,
              "page-sizes": [10, 20, 50, 100, 200],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pagination.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: _vm.loading },
              on: { click: _vm.handleCancel },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "danger",
                size: "small",
                loading: _vm.loading,
                disabled: _vm.selectedGameIds.length === 0,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("取消关联")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }